import axios from "@/axios.js";

export default {
  addItem({ commit }, item) {
    return new Promise((resolve, reject) => {
      debugger;
      axios
        .post("API/Lookup/AddFinancialPositionStatus", item)
        .then(response => {
          debugger;
          resolve(response);
          commit(
            "ADD_ITEM",
            Object.assign(item, { ID: response.data.ID })
          );
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  fetchDataListItems({ commit }) {
    debugger;
    return new Promise((resolve, reject) => {
      axios
        .get("API/Lookup/GetAllFinancialPositionStatus")
        .then(response => {
          debugger;
          resolve(response);
          commit("SET_FinancialPositionStatus", response.data.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  updateItem({commit}, item) {
    debugger;
    return new Promise((resolve, reject) => {
      axios
        .put("API/Lookup/UpdateFinancialPositionStatus", item)
        .then(response => {
          resolve(response);
          commit("UPDATE_FinancialPositionStatus", item);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  GetItemByID(context, itemid) {
    return new Promise((resolve, reject) => {
      debugger;
      axios
      .get("API/Lookup/GetFinicalPostionStatusById?Id=" + itemid)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  DeleteObject({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .delete("API/Lookup/DeleteFinancialPositionStatus?Id=" + item.id)
        .then(response => {
          resolve(response);
          commit("REMOVE_ITEM", item.ID);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

};
